// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "251dcc1e",
    "hash": "251dcc1e",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "251dcc1e",
    "semverString": null,
    "version": "1.0.0"
};
/* tslint:enable */
